import React from 'react';
import {Row, Col } from 'react-bootstrap';
import { makeStyles } from "@material-ui/core/styles";
import Button from '@material-ui/core/Button';
import './ProductPolicyCost.scss';


export default function ProductPolicyCost(props) {

  const useStyles = makeStyles((theme) => ({
    heroImage: {
      backgroundImage: `linear-gradient(to bottom, transparent 100%, white 0%), url(${props.data.image})`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
    },
  }));

  const classes = useStyles();

  return (
    <Row className="policy-cost" id="policy-cost">
        <Row className="m-0">
          <Col className={`hero-background-image text ${classes.heroImage}`}>
              <div className='policy-cost-contain'>
                <h2 className={`heading-text ${props.data.text.largeText ? "large-text" : ""}`}>{props.data.text.title}</h2>
                {props.data.text.paragraphs && props.data.text.paragraphs.map((p, i) => {
                  return <p className="text-left policy-cost-discription" key={i}>{p}</p>
                })}
                <Button variant="contained" color="primary" type="submit" fullWidth className='policy-cost-submit-button' onClick={props.action}>{props.data.callToActionText || "GET YOUR QUOTE"}</Button>
              </div>
          </Col>
        </Row>
    </Row>
  );
}



// WEBPACK FOOTER //
// ./src/components/LandingPages/ProductPolicyCost/ProductPolicyCost.js